import {ISubscriptionProduct, ISubscriptionProductResponse} from 'StripeSubscription/models/ISubscriptionProduct';

export function convertStripeSubscriptionProductToClient(product: ISubscriptionProductResponse): ISubscriptionProduct {
  return {
    ...product,
    price: product.priceInSmallestUnits / 100
  };
}
